module.exports = __webpack_public_path__ + "static/media/voice.64e4e7dc.svg";